/** Role helpers — stakeholder portal is read-only */

export const isStakeholder = (user) => user?.role === 'stakeholder';

export const canWriteReports = (user) =>
  user?.role === 'admin' || user?.role === 'editor' || user?.role === 'user';

export const isReadOnlyUser = (user) => isStakeholder(user);

export const getRoleLabel = (role) => {
  if (role === 'admin') return 'Yönetici';
  if (role === 'editor') return 'Editör';
  if (role === 'stakeholder') return 'Stakeholder';
  return 'Kullanıcı';
};

export const getDashboardHomePath = (role) =>
  role === 'stakeholder' ? '/dashboard/stakeholder' : '/dashboard';
